import React from 'react';
import { useLocation } from 'react-router-dom';
import PaymentResult from './PaymentResult/index';
import { createDynamicPaymentProps } from 'utils/servicePaymentUtils';

const GenericPaymentCancelled: React.FC = () => {
  const location = useLocation();
  
  console.log('[PAYMENT_DEBUG] GenericPaymentCancelled - Component rendering');
  console.log('[PAYMENT_DEBUG] GenericPaymentCancelled - Current pathname:', location.pathname);
  console.log('[PAYMENT_DEBUG] GenericPaymentCancelled - Location state:', location.state);
  console.log('[PAYMENT_DEBUG] GenericPaymentCancelled - URL search params:', location.search);
  
  const props = createDynamicPaymentProps(location.pathname, 'cancelled');
  
  console.log('[PAYMENT_DEBUG] GenericPaymentCancelled - Generated props from createDynamicPaymentProps:', props);
  console.log('[PAYMENT_DEBUG] GenericPaymentCancelled - Payment status:', props.paymentStatus);
  console.log('[PAYMENT_DEBUG] GenericPaymentCancelled - Service name:', props.serviceName);
  console.log('[PAYMENT_DEBUG] GenericPaymentCancelled - Provider name:', props.providerName);
  console.log('[PAYMENT_DEBUG] GenericPaymentCancelled - Service identifier:', props.serviceIdentifier);
  
  return <PaymentResult {...props} />;
};

export default GenericPaymentCancelled;